import authManager from '../auth-manager';
import axios from 'axios';
import { Logger } from '@aws-amplify/core';
import envConfig from '../env-config/';

/*******************************************************************************
 * web-apis-client.js is a collection of functions that handle web calls to the
 * /web-apis endpoints
 ******************************************************************************/

const log = new Logger('web-apis-client');

/*******************************************************************************
 * Gets the authorization token
 ******************************************************************************/
const getAuthorizationToken = async () => {
  const result = await authManager.getTokenForApiCall();

  return result.token;
};

/**
 * Gets survey content that has been configured in Kentico
 * @returns {Promise<SurveyContent>}
 */
const getSurveyContent = async () => {
  log.debug('getSurveyContent...');

  const options = {
    url: '/web-apis/get-survey-content',
    method: 'get',
    headers: {
      Authorization: await getAuthorizationToken(),
    },
  };

  const response = await axios(options);
  log.info('getSurveyContent ->', response);

  return response.data;
};

/**
 * Gets a list of customers case and leave Ids
 * @returns List of case and leave Ids
 */
const getCaseIds = async (customerId: any) => {
  log.debug('getCaseIds...');

  console.log('getCaseIds custoemrId: ' + customerId.value);
  const options = {
    url: '/web-apis/get-case-ids',
    method: 'get',
    headers: {
      Authorization: await getAuthorizationToken(),
      customerId: customerId.value,
    },
  };

  const response = await axios(options);
  log.info('getCaseIds ->', response);

  return response.data;
};

/**
 * Stores the survey
 */
const storeSurvey = async (survey: any) => {
  log.debug('storeSurvey...');

  const options = {
    url: envConfig.apiBaseUrl + '/web-apis/store-surveys',
    method: 'PUT',
    headers: {
      Authorization: await getAuthorizationToken(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(survey),
  };

  const response = await axios(options);
  log.info('storeSurvey ->', response);
};

const hasTasks = async (customerno: any) => {
  log.debug('hasTasks...');

  console.log('hasTasks customerno: ' + customerno.value);
  const options = {
    url: '/web-apis/has-tasks',
    method: 'get',
    headers: {
      Authorization: await getAuthorizationToken(),
      customerno: customerno.value,
    },
  };

  const response = await axios(options);
  log.info('hasTasks ->', response);

  return response.data;
};

/**
 * Decrypts an attribute received from UUS
 * @param encryptedInput The encrypted string to decrypt
 * @returns The decrypted string
 */
const decryptAttribute = async (encryptedInput: string): Promise<string> => {
  log.debug('decryptAttribute...');

  const options = {
    url: envConfig.apiBaseUrl + '/web-apis/decrypt-attribute',
    method: 'POST',
    headers: {
      Authorization: await getAuthorizationToken(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: { encryptedInput },
  };

  const response = await axios(options);
  log.info('decryptAttribute ->', response);

  return response.data;
};

/***************************************************************************************
 * exported api
 **************************************************************************************/
const webApisClient = {
  getAuthorizationToken,
  getSurveyContent,
  getCaseIds,
  storeSurvey,
  hasTasks,
  decryptAttribute
};

export default webApisClient;
